const defaultState = {message: []};

const helloWorld = (state=defaultState, action) => {
	switch(action.type) {
	case "HELLO_WORLD":
		return Object.assign({}, state, {message: "Hello World!"});
	default:
		return state;
	}
};

export default helloWorld;
